import React from 'react';
import { motion } from 'framer-motion';
import { FileText } from 'lucide-react';

const Terms = () => {
  return (
    <div className="bg-cobra-black min-h-screen" data-testid="terms-page">
      {/* Hero */}
      <section className="relative h-[40vh] flex items-center justify-center overflow-hidden">
        <div
          className="absolute inset-0 bg-cover bg-center"
          style={{
            backgroundImage: 'url(https://images.pexels.com/photos/4162451/pexels-photo-4162451.jpeg?auto=compress&cs=tinysrgb&w=1920)',
          }}
        />
        <div className="absolute inset-0 bg-cobra-black/85" />
        <motion.div
          initial={{ opacity: 0, y: 50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1 }}
          className="relative z-10 text-center px-4"
        >
          <FileText className="text-cobra-red mx-auto mb-4" size={48} />
          <h1 className="font-anton text-5xl md:text-7xl text-white uppercase tracking-wider">
            TERMS &amp; <span className="text-cobra-red">CONDITIONS</span>
          </h1>
        </motion.div>
      </section>

      {/* Content */}
      <section className="py-20 px-4 md:px-8 lg:px-12">
        <div className="max-w-4xl mx-auto">
          <motion.div
            initial={{ opacity: 0, y: 40 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="bg-cobra-dark/30 border border-white/10 rounded-sm p-8 md:p-12 space-y-8 font-manrope text-white/70 leading-relaxed"
          >
            <p>
              These terms govern your membership, class bookings, and use of the facilities and services at Cobra Thai. By purchasing a membership, booking a session, or training at our academy, you agree to the terms set out below.
            </p>

            {/* Highlighted No-Refund Policy */}
            <div className="bg-cobra-red/10 border border-cobra-red/40 rounded-sm p-6" data-testid="no-refund-section">
              <h2 className="font-anton text-2xl text-white uppercase tracking-wide mb-4">No Refund Policy</h2>
              <p className="text-white/80">
                <strong className="text-white">All membership fees, class packages, personal training packages, and other payments are strictly non-refundable and non-transferable.</strong> This includes, but is not limited to, monthly memberships, prepaid packages, drop-in sessions, and joining fees. Once a payment is made, it cannot be refunded, exchanged for cash, or transferred to another individual.
              </p>
              <p className="mt-3">
                Memberships cannot be paused, frozen, or extended except at the sole discretion of Cobra Thai management and only in exceptional circumstances (such as a documented medical condition). Any such request must be made in writing to{' '}
                <a href="mailto:info@cobrathai.com" className="text-cobra-red hover:underline">info@cobrathai.com</a>.
              </p>
            </div>

            <div>
              <h2 className="font-anton text-2xl text-white uppercase tracking-wide mb-4">1. Membership &amp; Payments</h2>
              <p>
                Membership fees are due in advance and grant access only for the period paid for. Failure to attend classes does not entitle you to a refund, credit, or extension. Prices, class schedules, and services may change at any time without prior notice.
              </p>
            </div>

            <div>
              <h2 className="font-anton text-2xl text-white uppercase tracking-wide mb-4">2. Assumption of Risk</h2>
              <p>
                Martial arts, combat sports, and physical training carry an inherent risk of injury. You acknowledge and agree that you train at your own risk. You confirm that you are in good physical health and have disclosed any medical conditions that may affect your ability to train safely. Cobra Thai, its coaches, and staff are not liable for any injury, loss, or damage sustained on the premises to the fullest extent permitted by law.
              </p>
            </div>

            <div>
              <h2 className="font-anton text-2xl text-white uppercase tracking-wide mb-4">3. Code of Conduct</h2>
              <p>
                Members are expected to behave respectfully toward coaches, staff, and other members at all times. Cobra Thai reserves the right to suspend or terminate a membership, without refund, for behaviour that endangers the safety or wellbeing of others, or that breaches these terms.
              </p>
            </div>

            <div>
              <h2 className="font-anton text-2xl text-white uppercase tracking-wide mb-4">4. Facilities &amp; Personal Belongings</h2>
              <p>
                Please use all equipment and facilities responsibly and follow the instructions of our coaches and staff. Cobra Thai is not responsible for the loss or theft of personal belongings on the premises.
              </p>
            </div>

            <div>
              <h2 className="font-anton text-2xl text-white uppercase tracking-wide mb-4">5. Changes to These Terms</h2>
              <p>
                We may update these terms from time to time. Any changes will be effective immediately upon posting to this website. Your continued use of our services constitutes acceptance of the updated terms.
              </p>
            </div>

            <div className="border-t border-white/10 pt-8 mt-8">
              <p>
                If you have any questions about these terms or our refund policy, please contact us at{' '}
                <a href="mailto:info@cobrathai.com" className="text-cobra-red hover:underline">
                  info@cobrathai.com
                </a>
                .
              </p>
            </div>
          </motion.div>
        </div>
      </section>
    </div>
  );
};

export default Terms;
